'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DiscountService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = require('../core/utils');

var _utils2 = require('./utils');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DiscountService = exports.DiscountService = function () {
    function DiscountService(winresCloudService, $filter, $q) {
        _classCallCheck(this, DiscountService);

        this.winresCloudService = winresCloudService;
        this.$filter = $filter;
        this.$q = $q;
    }

    // Not dummy
    //
    // Return
    // {
    //     DiscountPrice
    // }


    _createClass(DiscountService, [{
        key: 'useDiscountCode',
        value: function useDiscountCode(discountCode, productLines, passengers) {
            return this.winresCloudService.makeAuthenticatedRequest('UseDiscountCode', {
                'DiscountCode': discountCode,
                'ProductLines': (0, _utils2.toSimpleProductLines)(productLines),
                'Passengers': passengers
            }, true);
        }
    }, {
        key: 'getDiscountCodeFromLocalStorage',
        value: function getDiscountCodeFromLocalStorage() {
            return window.localStorage.getItem('discountCode');
        }
    }, {
        key: 'saveDiscountCodeToLocalStorage',
        value: function saveDiscountCodeToLocalStorage(discountCode) {
            window.localStorage.setItem('discountCode', discountCode);
        }
    }, {
        key: 'removeDiscountCodeFromLocalStorage',
        value: function removeDiscountCodeFromLocalStorage() {
            window.localStorage.removeItem('discountCode');
        }
    }, {
        key: 'addDiscountProductToCart',
        value: function addDiscountProductToCart(wrc, discountCode, discountPrice, destCode, prodCode, beginDate, endDate, name, scope) {
            var discountProduct = this.getDiscountProduct(discountPrice, destCode, prodCode, beginDate, endDate, name);

            var productLine = wrc.findOrCreateProductLineByProduct(discountProduct);
            productLine.IsDiscountProduct = true;
            productLine.DiscountCode = discountCode;
            productLine.DiscountScope = scope;
            productLine.Amount = 1;
            productLine.UnitPrice = discountPrice;
            productLine.TotalPrice = discountPrice;

            // Get discount code from discount product
            // const discountProduct = _.find(context.Products, product => product.IsDiscountProduct);
            // if (discountProduct) {
            //     context.DiscountCode = discountProduct.DiscountCode;
            // }

            // this.addDiscountCodeAndProductToContext(wrc.context);
        }
    }, {
        key: 'createDiscountProducts',
        value: function createDiscountProducts(wrc) {
            // Seperate discount products from products
            wrc.context.DiscountProducts = _.filter(wrc.context.Products, function (product) {
                return product.IsDiscountProduct;
            });

            // Remove discount product
            wrc.context.Products = _.filter(wrc.context.Products, function (product) {
                return !product.IsDiscountProduct;
            });
        }
    }, {
        key: 'getDiscountProductFromCart',
        value: function getDiscountProductFromCart(wrc) {
            return wrc.context.DiscountProducts ? _.find(wrc.context.DiscountProducts, function (line) {
                return line.IsDiscountProduct;
            }) : null;
        }
    }, {
        key: 'removeDiscountProductFromCart',
        value: function removeDiscountProductFromCart(wrc) {
            var discountProduct = this.getDiscountProductFromCart(wrc);

            if (discountProduct) {
                _.remove(wrc.context.DiscountProducts, discountProduct);
            }

            delete wrc.context.DiscountCode;
        }
    }, {
        key: 'clearDiscountProductsFromCart',
        value: function clearDiscountProductsFromCart(wrc) {
            wrc.context.DiscountProducts = [];
        }

        // Pseudo discount product

    }, {
        key: 'getDiscountProduct',
        value: function getDiscountProduct(discountPrice, destCode, prodCode, beginDate, endDate, name) {
            return {
                Link: {
                    DestCode: destCode,
                    ProdCode: prodCode
                },
                DestinationInfo: {
                    DestinationCode: destCode + '-DISCOUNT',
                    ProductCode: prodCode + '-DISCOUNT',
                    ProductName: name
                },
                BeginDate: beginDate,
                EndDate: endDate,

                Price: '' + discountPrice,
                ReservablePrices: [{
                    Index: null,
                    Label: 'price.labels.accommodation',
                    Price: discountPrice
                }]
            };
        }
    }, {
        key: 'getGiftCardSettings',
        value: function getGiftCardSettings() {
            var _this = this;

            if (this._giftCardSettings) {
                return this.$q.resolve(this._giftCardSettings);
            } else {
                var request = this.winresCloudService.makeAuthenticatedRequest('GetGiftCardSettings', {}, true);
                return request.then(function (settings) {
                    _this._giftCardSettings = settings;
                    return settings;
                });
            }
        }
    }, {
        key: 'checkGiftCard',
        value: function checkGiftCard(giftCardNumber) {
            return this.winresCloudService.makeAuthenticatedRequest('CheckGiftCard', {
                GiftCardNumber: giftCardNumber
            }, true);
        }
    }]);

    return DiscountService;
}();

DiscountService.$inject = ['winresCloudService', '$filter', '$q'];


//////////////////
// WEBPACK FOOTER
// ./src/winresCloud/discountService.js
// module id = 577
// module chunks = 2